import { z } from 'zod';

export const EvaluateShortAnswerSchema = z.object({
  questionId: z
    .string()
    .uuid()
    .describe('The ID of the generated question session'),
  userAnswer: z.string().min(1).describe('The answer provided by the user'),
});

export type IEvaluateShortAnswerDto = z.infer<typeof EvaluateShortAnswerSchema>;
